import styled from "styled-components";
import { Link } from "react-router-dom";
import medal from "assets/level-recommendation/medal.svg";

export const Section = styled.section`
  padding: 20px 8%;
  text-align: left;
  background-color: #1070b6;
  background-repeat: repeat;
  @media (max-width: 767px) {
    padding: 16px;
  }
`;
export const Language = styled.h1`
  color: white;
  font-size: clamp(22px, 2vw, 32px);
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 0 12px;
`;
export const Card = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 16px 20px;
  background: white;
  border-radius: 20px;
  color: #083d69;
  min-width: 0;
  @media (max-width: 1100px) {
    gap: 16px;
  }
  @media (max-width: 767px) {
    flex-wrap: wrap;
    padding: 16px;
    gap: 16px;
  }
`;
export const Badge = styled.div`
  position: relative;
  flex: 0 0 17%;
  width: 17%;
  max-width: 192px;
  font-size: clamp(16px, 1.4vw, 22px);
  aspect-ratio: 1;
  background: url(${medal}) center / contain no-repeat;
  color: #005487;
  font-weight: 800;
  text-align: center;
  .medal-label {
    position: absolute;
    left: 32.5%;
    top: 27.5%;
    width: 47.5%;
    height: 37.5%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 1;
  }
  .medal-prefix {
    font-size: 1em;
    line-height: 1.1;
  }
  .medal-number {
    font-size: 2.2em;
    line-height: 1;
  }
  .medal-title {
    max-width: 100%;
    font-size: 1.3em;
    line-height: 1.1;
    overflow-wrap: anywhere;
  }
  .medal-title-long {
    font-size: 0.72em;
  }
  @media (max-width: 1100px) {
    font-size: 16px;
  }
  @media (max-width: 767px) {
    flex-basis: 100px;
    width: 100px;
    font-size: 13px;
  }
`;
// Crop the portrait above the design's example label; render the saved level below.
export const MoveDownBadge = styled(Badge)`
  background: none;
  aspect-ratio: auto;
  svg {
    display: block;
    width: 100%;
    aspect-ratio: 285 / 249;
    overflow: hidden;
  }
  .review-level {
    display: block;
    width: fit-content;
    min-width: 56%;
    max-width: 100%;
    margin: 0 auto;
    padding: 6px 12px;
    border-radius: 14px;
    background: #ffda36;
    line-height: 1.2;
    overflow-wrap: anywhere;
  }
`;
export const Content = styled.div`
  flex: 1;
  min-width: 0;
  h2 {
    font-size: clamp(20px, 1.7vw, 28px);
    font-weight: 700;
    line-height: 1.2;
    margin: 0 0 8px;
    color: #083d69;
  }
  p {
    color: #52617f;
    margin: 0 0 12px;
    font-size: 14px;
    line-height: 1.4;
  }
  @media (max-width: 767px) {
    flex-basis: calc(100% - 116px);
  }
`;
// The supplied artwork includes the help icon. Keep its link over that icon.
export const Help = styled.a`
  position: absolute;
  right: 0;
  top: 0;
  width: 14%;
  height: 17%;
  min-width: 44px;
  min-height: 44px;
  border-radius: 50%;
  &:focus-visible {
    outline: 3px solid #0076c8;
    outline-offset: -3px;
  }
`;
export const ProgressLabel = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  color: #52617f;
  margin-bottom: 8px;
  strong {
    color: #007bd1;
  }
`;
export const Progress = styled.div`
  position: relative;
  height: 22px;
  border-radius: 20px;
  overflow: hidden;
  background: #d3eafe;
  margin-bottom: 12px;
  span {
    position: absolute;
    inset: 0;
    text-align: center;
    font-weight: 700;
    line-height: 22px;
  }
`;
export const ProgressFill = styled.div`
  height: 100%;
  border-radius: inherit;
  background: #ffda36;
`;
export const Curriculum = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 8px 18px;
  border-radius: 20px;
  background: #d0e9ff;
  color: #0076c8;
  font-size: 16px;
  font-weight: 700;
  &:hover {
    background: #b8ddfb;
    color: #005b9e;
  }
  &:focus-visible {
    outline: 3px solid #0076c8;
    outline-offset: 3px;
  }
`;
// Show the complete right-hand panel from the supplied design, including its
// encouragement copy. The saved level, recommendation and progress remain live.
export const Illustration = styled.div`
  flex: 0 0 30%;
  max-width: 360px;
  min-width: 0;
  padding-left: 16px;
  border-left: 1px solid #d3eafe;
  @media (max-width: 767px) {
    flex-basis: 100%;
    width: 100%;
    max-width: 280px;
    margin: 0 auto;
    padding: 16px 0 0;
    border-left: 0;
    border-top: 1px solid #d3eafe;
  }
`;
export const Artwork = styled.div`
  position: relative;
  aspect-ratio: 672 / 402;
  overflow: hidden;
  border-radius: 0 6% 6% 0;
  img {
    position: absolute;
    max-width: none;
    width: 304.762%;
    height: auto;
    left: -194.94%;
    top: -34.826%;
  }
`;
// This design's divider sits slightly farther right than the other panels.
export const MoveDownArtwork = styled(Artwork)`
  aspect-ratio: 680 / 426;
  img {
    width: 319.412%;
    left: -208.824%;
    top: -34.742%;
  }
`;
// Enlarge the illustrated panel without spending banner height on the source
// image's blue frame. Preserve the complete journey and its original proportions.
export const StartArtwork = styled.div`
  position: relative;
  width: min(100%, 884px, 83vh);
  aspect-ratio: 1744 / 592;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 20px;
  img {
    position: absolute;
    max-width: none;
    width: 106.881%;
    height: auto;
    left: -3.44%;
    top: -30.405%;
  }
`;
